(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	// Closes all popups by clearing hash
	var closePopups = function () {
		var st = $(document).scrollTop(); // Store scroll position
		window.location.hash = '#'; // Bump CSS :target styling
		$(document).scrollTop(st); // Restore scroll position

		// Update URL
		if ('replaceState' in window.history) {
			window.history.pushState('', document.title, window.location.pathname + window.location.search);
		}
	};

	// Hook up close clicks
	$('.popup, .popup__close').click(function (e) {
		// Only direct clicks
		if (e.target == this) {
			e.preventDefault();
			closePopups();
		}
	});

	// Popup templates
	$('[data-popup-template]').click(function () {
		var clicked = $(this);
		var popupId = clicked.attr('href').substr(1);
		var templateId = clicked.attr('data-popup-template');

		$('#' + popupId).find('div.popup-template-content').html($('#' + templateId).html());
	});


	// Opens popup with id id
	var openPopup = function (id) {
		var st = $(document).scrollTop();

		window.location.hash = '#' + id;

		$(document).scrollTop(st);
	};
	

	function getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	// Automatically open these poups on pageload
	var autoOpen = $('[data-popup-auto-open]');

	if (autoOpen.length) {
		var autoOpenId = autoOpen.eq(0).attr('id'); // We can only open one popup (the first one)
		var alreadyBeenOpen = window.localStorage.getItem('popup_auto_open_' + autoOpenId); // Only open it once
		var show = false;
		

		var ref = getParameterByName('ref');
		if (
			ref == 'nicator' || 
			ref == 'lindqvistbygg' || 
			ref == 'mfsfastighetsservice.se'
		) {
			show = true;
		}


		if (!alreadyBeenOpen && show) {
			window.localStorage.setItem('popup_auto_open_' + autoOpenId, true);
			
			setTimeout(function (){ 
				openPopup(autoOpenId);
			}, 500);
			
		}
	}

})();
